import { animateOnView, shouldReduceMotion } from '@theme/utilities';

// mark document so CSS knows JS is running
if (typeof document !== 'undefined') {
  document.documentElement.classList.add('js-enabled');
}

function initProductCardAnimations() {
  if (typeof window !== 'undefined' && shouldReduceMotion()) {
    return;
  }

  animateOnView('.product-card:not([data-pc-animated])', 'animate-in', {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1,
  });

  document
    .querySelectorAll('.product-card:not([data-pc-animated])')
    .forEach((card) => {
      card.setAttribute('data-pc-animated', 'true');
    });
}

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initProductCardAnimations);

  if (window.Shopify && Shopify.designMode) {
    const reinit = () => {
      requestAnimationFrame(() => {
        initProductCardAnimations();
      });
    };

    document.addEventListener('shopify:section:load', reinit);
    document.addEventListener('shopify:section:reorder', reinit);
    document.addEventListener('shopify:section:select', reinit);
    document.addEventListener('shopify:block:select', reinit);
  }
}
